import {IBackendCaller} from "./backendCaller";

export interface IVillageScheduleService {
  //get village schedule by a given village id
  getVillageSchedule: (villageId: string) => Promise<any>;
  getMultiVillageSchedule: (
    villageIds: string[] | null | undefined
  ) => Promise<any>;
}

export class VillageScheduleService implements IVillageScheduleService {
  backendCaller: IBackendCaller;

  constructor(backendCaller: IBackendCaller) {
    this.backendCaller = backendCaller;
  }

  getVillageSchedule = async (villageId: string) => {
    return await this.backendCaller.callApi(
      "GET",
      `/api/villageSchedules?villageId=${villageId}`,
      null,
      null,
      true
    );
  };

  getMultiVillageSchedule = async (villageIds: string[] | null | undefined) => {
    return await this.backendCaller.callApi(
      "GET",
      `/api/villageSchedules/multiVillage?villageIds=${villageIds ?? ""}`,
      null,
      null,
      true
    );
  };
}
